import { FormatIcu } from '@tolgee/format-icu'
import { DevTools, Tolgee, TolgeeStaticData } from '@tolgee/web'

import clientConfig from '@/libs/config/client'

export async function getStaticData<T extends string>(
  languages: Readonly<T[]> | T[]
) {
  const result: Record<string, unknown> = {}

  for (const lang of languages) {
    if (!result[lang]) {
      try {
        const mod = await import(`../../../i18n/${lang}.json`)
        result[lang] = mod.default
      } catch {
        const mod = await import(`../../../i18n/en_SG.json`)
        result[lang] = mod.default
      }
    }
  }

  return result as TolgeeStaticData
}

export const TolgeeBase = () =>
  Tolgee().use(FormatIcu()).use(DevTools()).updateDefaults({
    apiKey: clientConfig.tolgeeApiKey,
    apiUrl: clientConfig.tolgeeApiUrl,
  })
